export const environment = {
  production: true,

  // f01-prod
  apiBaseUrl: 'https://f01.fareilweb.com/loculi',
  appBaseUrl: 'https://loculi.fareilweb.com',

  // // f01-dev + localhost
  // apiBaseUrl: 'https://f01.fareilweb.com/loculi-dev',
  // appBaseUrl: 'http://localhost:8100',

  // // localhost
  // apiBaseUrl: 'https://localhost/loculi',
  // appBaseUrl: 'http://localhost:8100',

  enableSezioneField: false,
};
